import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { useNotify } from '../context/NotifyContext';
import UserAvatar from './UserAvatar';
import { userDisplayLabel } from '../utils/userDisplayLabel';

/**
 * Profile picture upload (Cloudinary via API). Calls refreshUser on success.
 */
export default function ProfilePhotoSection({ user, refreshUser }) {
  const { showSuccess, showError } = useNotify();
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    const input = e.target;
    if (!file) return;
    const fd = new FormData();
    fd.append('photo', file);
    setUploading(true);
    try {
      await authAPI.uploadProfilePhoto(fd);
      await refreshUser?.();
      showSuccess('Profile photo updated.');
    } catch (err) {
      const msg = err.response?.data?.message ? `Error: ${err.response.data.message}` : 'Error: Failed to upload photo';
      showError(msg.replace(/^Error:\s*/, '') || 'Failed to upload photo');
    } finally {
      setUploading(false);
      input.value = '';
    }
  };

  const label = userDisplayLabel(user);

  return (
    <div className="card account-settings-card">
      <h2 className="card-title" style={{ marginBottom: '8px' }}>Profile picture</h2>
      <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: '16px' }}>
        Upload a photo for your account. It appears in messages and wherever your name is shown.
      </p>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', flexWrap: 'wrap' }}>
        <UserAvatar photoUrl={user?.profilePhotoUrl} label={label} size={88} />
        <div>
          <label className="form-label">Choose image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleChange}
            disabled={uploading}
            className="form-input"
            style={{ padding: '8px', marginTop: '4px' }}
          />
          {uploading && (
            <p style={{ margin: '8px 0 0 0', fontSize: '0.8125rem', color: 'var(--text-secondary)' }}>Uploading…</p>
          )}
        </div>
      </div>
    </div>
  );
}
